<template>
  <!-- 順番 -->
  <div class="answer-multioption order">
    <button @click="selected = []" :disabled="sent" class="reset">
      リセット
    </button>
    <img v-if="sent && tof" src="@/assets/img/maru.png" />
    <img v-else-if="sent && !tof" src="@/assets/img/batsu.png" />
    <ol class="answer-list order-list" :class="question.question.class">
      <li
        v-for="(q, idx) in optionOrder"
        :key="`opt${idx}`"
        :class="{
          'answer-correct': sent && (tof && answer[idx]),
          'answer-incorrect': sent && (!tof || !answer[idx]),
        }"
        @click="
          () => {
            if (!sent) {
              if (selected.indexOf(q) === -1) {
                selected.push(q);
              }
            }
          }
        "
      >
        <div class="boxes">
          <span v-if="sent" class="num-box answer">
            {{ correctOrder.indexOf(q) + 1 }}
          </span>
          <span v-if="selected.indexOf(q) !== -1" class="num-box">
            {{ selected.indexOf(q) + 1 }}
          </span>
          <span v-else class="num-box">-</span>
        </div>
        <div class="options">{{ option[idx] }}</div>
      </li>
    </ol>
  </div>
</template>


<script>
/* eslint-disable no-console */
import CircleNum from "@/tools/circleNum";
import randomizer from "@/tools/randomizer";

export default {
  data() {
    return {
      selected: []
    };
  },
  mounted() {
    console.log(this.option);
    if (!this.optionOrder) {
      if (this.question.question.random) {
        const randomizeOrder = randomizer(
          this.question.question.option.map((e, idx) => idx)
        );
        console.log(randomizeOrder);
        this.$store.commit("setOptionOrder", randomizeOrder);
      } else {
        this.$store.commit(
          "setOptionOrder",
          this.question.question.option.map((e, idx) => idx)
        );
      }
    }

    if (this.sent) {
      if (!this.response) {
        this.selected = [];
        return;
      }
      this.selected = this.response;
    }
  },
  computed: {
    circleNum() {
      return CircleNum;
    },
    response() {
      return this.$store.getters.response;
    },
    sent() {
      return this.$store.getters.sent || this.$store.state.modal;
    },
    modal() {
      return this.$store.state.modal;
    },
    option() {
      const options = this.$store.getters.option;
      if (Array.isArray(options)) {
        return options.map((e, idx) => {
          if (e) {
            return e;
          }
          return this.circleNum[idx];
        });
      }
      return [];
    },
    optionOrder() {
      return this.$store.getters.optionOrder;
    },
    question() {
      return this.$store.getters.question;
    },
    selectedText() {
      return this.selected.map(e => {
        return this.correctText[e];
      });
    },
    correctOrder() {
      return this.$store.getters.answer;
    },
    correctText() {
      return this.question.question.answer.map(e => {
        return this.question.question.option[e - 1];
      });
    },
    answer() {
      return this.selected.map((e, idx) => {
        return e === this.correctOrder[idx];
      });
    },
    tof() {
      return (
        this.answer.length === this.correctOrder.length &&
        this.answer.every(e => e === true)
      );
    }
  },
  watch: {
    selected(nv) {
      if (!this.sent) {
        this.$store.commit("setResponse", {
          response: nv,
          correct: this.tof
        });
      }
    }
  }
};
</script>

<style scoped>
.answer {
  color: #d22;
  font-size: 80%;
}

.num-box {
  display: inline-block;
  margin: 2px 0;
  width: 2em;
  background-color: #fff;
  border-radius: 10px;

  border: solid 3px #c4c4c4;
  color: #444;

  text-align: center;
}

.num-box.answer {
  font-size: 20px;
  border: solid 3px #ff4444;
  margin-right: 5px;
}

.answer-list.center li {
  text-align: center;
}

.list-btn {
  display: inline-block;
  width: calc(100% - 3em);
}

.item,
.answer-list li {
  display: flex;
}

.item div.boxes,
.answer-list li div.boxes {
  flex: 0 0 5em;
  text-align: right;
}

.item div.options,
.answer-list li div.options {
  flex: 0 0 calc(100% - 5em);
  padding-left: 0.5em;
}

.reset {
  display: block;
  margin: 1rem 0 0 auto;
  width: 9em;
  font-size: 1.5rem;
  line-height: 2.5rem;
  background: #3553a7;
  border-radius: 4rem;
  -webkit-transition: 0.3s;
  transition: 0.3s;
  -webkit-box-shadow: 3px 3px 15px 3px rgba(0, 0, 0, 0.1);
  box-shadow: 3px 3px 15px 3px rgba(0, 0, 0, 0.1);
  color: #fff;
  letter-spacing: 0.2em;

  border: none;
}

.reset:disabled {
  opacity: 0.5;
}
</style>